export default __webpack_public_path__ + "static/media/skip-back.81ad9f15.svg";